export default __webpack_public_path__ + "static/media/icon_mobilePrepaid.7f92a48d.svg";